import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import logo512 from '../images/logo512.png';
import SearchBar from './Searchbar.jsx';


function Navbar(props) {
    const [theme, setTheme] = useState("dark");
    

    useEffect(() => {
      document.body.setAttribute("data-bs-theme", theme);
      
    }, [theme]);



  return (
    <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <div class="container-fluid">
        <Link class="navbar-brand" to="/"><img src={logo512} style={{width:"48px", height:"48px"}} /></Link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
            <Link class="nav-link active" aria-current="page" to="/">Home</Link>
            </li>
            <li class="nav-item">
            <Link class="nav-link active" aria-current="page" to="/Highlights">Highlights</Link>
            </li>
            <li class="nav-item dropdown">
            <Link class="nav-link dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Group
            </Link>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="https://www.roblox.com/communities/8124498/5O3rd-Battalion#!/about">503rd</a></li>
                <li><a class="dropdown-item" href="https://www.roblox.com/communities/4929233/ilitary-Police-Corps#!/affiliates">MPC</a></li>
                <li><hr class="dropdown-divider"></hr></li>
                <li><a class="dropdown-item" href="https://www.roblox.com/communities/3108077/United-States-Army#!/about">USAR</a></li>
            </ul>
            </li>
            <li class="nav-item">
            <Link class="nav-link disabled" aria-disabled="true" to='/Dashboard'>Dashboard</Link> {/* nav-link, to enable it. */}
            </li>
            <li class="nav-item" style={{visibility: "hidden"}}> {/* Hidden for now, will be used later------------------------------------------------------------------------------------------------------------------ */}
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onChange={() => setTheme(theme === "light" ? "dark" : "light")} />
                    <label class="form-check-label" for="flexSwitchCheckDefault">☀</label>
                </div>
            </li>
        </ul>
            <SearchBar />
            
        </div>
    </div>
    </nav>
    
  );
}

export default Navbar;